'use client';

import React, { useEffect, useState } from 'react';
import { Form, Input, Select, ErrorMessage, useFormFieldError, useFormInstance } from '@weareconceptstudio/form';
import FormAddress from '@/components/common/Form/FormAddress';

const AU_STATES = [
	{ name: 'Australian Capital Territory', value: 'Australian Capital Territory', id: 'ACT' },
	{ name: 'New South Wales', value: 'New South Wales', id: 'NSW' },
	{ name: 'Northern Territory', value: 'Northern Territory', id: 'NT' },
	{ name: 'Queensland', value: 'Queensland', id: 'QLD' },
	{ name: 'South Australia', value: 'South Australia', id: 'SA' },
	{ name: 'Tasmania', value: 'Tasmania', id: 'TAS' },
	{ name: 'Victoria', value: 'Victoria', id: 'VIC' },
	{ name: 'Western Australia', value: 'Western Australia', id: 'WA' },
];

const fullRowFlexItem = {
	width: '100%',
	maxWidth: '100%',
	flexBasis: '100%',
	flexGrow: 1,
	minWidth: 0,
	boxSizing: 'border-box',
};

const toggleLinkStyle = {
	cursor: 'pointer',
	textDecoration: 'underline',
	fontSize: '14px',
	color: '#1890ff',
	fontWeight: 500,
	border: 'none',
	background: 'none',
	padding: 0,
};

const CheckoutAddressField = ({ setFields, placeholder = 'Address *' }) => {
	const hasAddressError = !!useFormFieldError('address');
	const { setValue, unregister, formState } = useFormInstance();
	const [autoFill, setAutoFill] = useState(!formState?.defaultValues?.id);

	const manualRequired = !autoFill;

	useEffect(() => {
		if (!autoFill) {
			unregister('address');
		}
	}, [autoFill, unregister]);

	const toggleAutoFill = () => setAutoFill((prev) => !prev);

	return (
		<>
			{autoFill ? (
				<div
					className={`form-item checkout-address-field ${hasAddressError ? 'has-error' : ''}`}
					style={fullRowFlexItem}>
					<div
						className='checkout-address-autofill'
						style={{ width: '100%' }}>
						<div
							style={{
								display: 'flex',
								justifyContent: 'space-between',
								alignItems: 'center',
								flexWrap: 'wrap',
								gap: '8px',
								marginBottom: '8px',
								width: '100%',
							}}>
							<span />
							<button
								type='button'
								className='autofill-toggle-link'
								style={toggleLinkStyle}
								onClick={toggleAutoFill}
								tabIndex={0}>
								Turn off autocomplete
							</button>
						</div>
						<Form.Item
							name='address'
							errorKey='address'
							required
							requiredMessage='addressIsRequired'
							noStyle>
							<FormAddress
								setValue={setValue}
								setFields={setFields}
								toggleAutoFill={toggleAutoFill}
								placeholder={placeholder}
								onChange={() => {
									setValue('address', '', { shouldValidate: false });
								}}
							/>
						</Form.Item>
						<ErrorMessage
							name='address'
							as={<div className='error-message' />}
						/>
					</div>
				</div>
			) : null}
			{autoFill ? (
				<Form.Item
					name='phone'
					errorKey='phone'
					className={autoFill ? 'checkout-address-phone-autofill-mode' : undefined}>
					<Input placeholder='Phone *' />
				</Form.Item>
			) : null}

			<div
				hidden={autoFill}
				style={autoFill ? undefined : { display: 'contents' }}>
				<Form.Item
					name='apartment'
					errorKey='apartment'
					required={false}>
					<Input placeholder='Unit no' />
				</Form.Item>
				<Form.Item
					name='street_address'
					errorKey='street address'
					required={manualRequired}>
					<Input placeholder='Street address *' />
				</Form.Item>
				<Form.Item
					name='suburb'
					errorKey='suburb'
					required={manualRequired}>
					<Input placeholder='Suburb *' />
				</Form.Item>
				<Form.Item
					name='state'
					errorKey='state'
					required={manualRequired}>
					<Select
						options={AU_STATES}
						optionKey='name'
						optionValue='id'
						placeholder='Select state'
					/>
				</Form.Item>
				<Form.Item
					name='postcode'
					errorKey='postcode'
					required={manualRequired}>
					<Input placeholder='Postcode *' />
				</Form.Item>
				<Form.Item
					name='phone'
					errorKey='phone'
					className={'checkout-address-phone-autofill-mode'}>
					<Input placeholder='Phone *' />
				</Form.Item>
			</div>
			{!autoFill && !formState?.defaultValues?.id ? (
				<div
					style={{
						...fullRowFlexItem,
						padding: '0 calc(var(--account_formItemDistance, var(--sp5x, 20px)) / 2)',
						marginBottom: 'var(--account_antFormItemMTop, var(--sp4x, 16px))',
						textAlign: 'right',
					}}>
					<button
						type='button'
						className='autofill-toggle-link'
						style={toggleLinkStyle}
						onClick={toggleAutoFill}
						tabIndex={0}>
						Turn on autocomplete
					</button>
				</div>
			) : null}
		</>
	);
};

export default CheckoutAddressField;
